module.exports = __webpack_public_path__ + "img/OAMH.97cfe50d.jpg";